import React from "react";

import { getTranslation } from "../../../../helpers/getLanguage";
import CustomCheckbox from "../../../inputs/CustomCheckbox";

const HeaderTableAttributes = ({ sort, handleSortChange, handlePickedAllAttributes, selectedAll }) => {
  const SortableCell = ({ name, label }) => {
    const isActive = name === sort.field;

    return (
      <div className="flex align-center width-100">
        <span
          className={"attributes-row-text pointer" + (isActive ? " active" : "")}
          onClick={() => handleSortChange(name)}
        >
          {label}
        </span>
        {isActive && <div className={"sort-triangle-icon" + (sort.asc ? " asc" : "")}></div>}
      </div>
    );
  };

  return (
    <div className="attributes-container-header">
      <div className="attributes-row-header flex align-center">
        <div className="attributes-row-checkbox flex-center">
          <CustomCheckbox
            checked={selectedAll}
            handleChange={() => handlePickedAllAttributes()}
            customClass="attributes-checkbox"
          />
        </div>

        <div className="attributes-row-name flex align-center">
          <SortableCell name="name" label={getTranslation("SORTABLE_CELL_NAME")} />
        </div>

        <div className="attributes-row-type flex align-center">
          <SortableCell name="type" label={getTranslation("SORTABLE_CELL_TYPE")} />
        </div>

        <div className="attributes-row-description">
          <SortableCell name="description" label={getTranslation("SORTABLE_CELL_DESCRIPTION")} />
        </div>

        <div className="attributes-row-component flex align-center">
          <SortableCell name="component" label={getTranslation("SORTABLE_CELL_COMPONENT_NAME")} />
        </div>

        <div className="attributes-row-importance flex align-center">
          <SortableCell name="importance" label={getTranslation("SORTABLE_CELL_IMPORTANCE")} />
        </div>

        <div className="attributes-row-project flex align-center">
          <SortableCell name="project" label={getTranslation("SORTABLE_CELL_PROJECT_NAME")} />
        </div>
      </div>
    </div>
  );
};

export default HeaderTableAttributes;
